import { mapKeys, omitBy, upperFirst } from 'lodash';
import qs from 'qs';
import { TagsFilters } from 'tags/models/tags';

export const prepareTagsFilterParams = (filters?: TagsFilters) => {
  if (!filters) {
    return '';
  }

  const cleanedFilters = omitBy(filters, (value) => {
    return !value;
  });

  const searchParams = mapKeys(cleanedFilters, (_, key) => upperFirst(key)) as Record<
    string,
    string
  >;

  return qs.stringify(searchParams);
};
